export default "__VITE_ASSET__db9cda69__"